import React, { useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import EnvFilterBar from 'components/Apps/EnvironmentMonitor/EnvFilterBar/EnvFilterBar'
import 'styles/app/apps/EnvironmentMonitor/environment-monitor.scss'
import Pew from 'routes/App/Apps/EnvironmentMonitor/Pew'
import Current from 'routes/App/Apps/EnvironmentMonitor/Current'
import Tide from 'routes/App/Apps/EnvironmentMonitor/Tide'
import Oxygen from 'routes/App/Apps/EnvironmentMonitor/Oxygen'
import Temperature from 'routes/App/Apps/EnvironmentMonitor/Temperature'
import Saturation from 'routes/App/Apps/EnvironmentMonitor/Saturation'
import Transparency from 'routes/App/Apps/EnvironmentMonitor/Transparency'
import CloudCover from 'routes/App/Apps/EnvironmentMonitor/CloudCover'
import {
  TYPE_PEW,
  TYPE_OXYGEN,
  TYPE_TIDE,
  TYPE_TEMPERATURE,
  TYPE_SPEED,
  TYPE_SATURATION,
  TYPE_TRANSPARENCY,
  TYPE_CLOUD_COVER,
} from 'helpers/environmentMonitor'
import { logMonitorActivity } from 'reducers/environmentMonitor/reducer'
import { EVENT_TYPES } from '../MonitorsAndAlerts/logTypes'

function EnvironmentMonitor({
  activeViewType,
  currentApp,
  activeSite,
  logMonitorActivity,
  history: {
    location: { pathname },
  },
}) {
  const components = {
    [`${TYPE_PEW}`]: Pew,
    [`${TYPE_OXYGEN}`]: Oxygen,
    [`${TYPE_TIDE}`]: Tide,
    [`${TYPE_TEMPERATURE}`]: Temperature,
    [`${TYPE_SPEED}`]: Current,
    [`${TYPE_SATURATION}`]: Saturation,
    [`${TYPE_TRANSPARENCY}`]: Transparency,
    [`${TYPE_CLOUD_COVER}`]: CloudCover,
  }
  const Sensor = components[activeViewType]
  const { name, id: licenseeApplicationId, applicationId } = currentApp

  useEffect(() => {
    const logData = {
      licensee_application: licenseeApplicationId,
      application: applicationId,
      site: activeSite,
      event_name: EVENT_TYPES.APP_VIEW,
      tab_name: activeViewType,
      application_url: pathname,
      referrer: localStorage.getItem('referrer') || null,
    }

    logMonitorActivity(logData)
  }, [])

  return (
    <div className="module environment-module">
      <div className="module-head">
        <Typography className="module-title" variant="h5">
          {name}
        </Typography>
        <div className="module-filter">
          <EnvFilterBar currentApp={currentApp} />
        </div>
      </div>
      <div className="module-content">
        <Grid className="sensor-wrap" container spacing={2}>
          <Sensor />
        </Grid>
      </div>
    </div>
  )
}

export default connect(
  state => ({
    activeViewType: state.getIn(['environmentMonitor', 'viewType']),
    activeSite: state.getIn(['profile', 'siteId']),
  }),
  {
    logMonitorActivity,
  },
)(EnvironmentMonitor)
